import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Lists } from '../../services/lists.service';
import { CommonUtilService } from '../../services/CommonUtil.service';
import { CompanyinboxService } from '../../../results/inboxintel/companies/services/companyinbox.service';
import { ContactinboxService } from '../../../results/inboxintel/contacts/services/contactinbox.service';
import { InboxintelService } from '../../../results/inboxintel/services/inboxintel.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SearchService } from '../../../results/search/services/search.service';
import { AccountAttributesEnum, VisitorIntelProviderEnum } from '../../enums';
import { ListApiService, TagsApiService, VisitorIntelApiService } from '../../services/api';
import { ListItemDto, ListPayloadDto, ListResponseDto, SaveTagDto, TagsDto, VisitorIntelCompanyDto } from '../../dto';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CREATE_TAG_LOADING_TAG, GET_TAG_LOADING_TAG } from '../../constants';
import { LoadingService, TagService } from '../../services';
import { SelectSearchParamsInterface, StoreInterface } from '../';

@UntilDestroy()
@Component({
    selector: 'app-add-to-list-contacts',
    templateUrl: './add-to-list-contacts.component.html',
    standalone: false
})
export class AddToListContactsComponent {
    readonly isCreateTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(CREATE_TAG_LOADING_TAG);
    readonly isGetTagLoading$: Observable<boolean> = this.loadingService.getIsLoading(GET_TAG_LOADING_TAG);

    selectedType: string = '';
    contactListId: number | string = '';
    newContactListName = '';
    companyListId: number | string = '';
    newCompanyListName = '';
    suppressionListId: number | string = '';
    newSuppressionListName = '';
    isPublicContactList: boolean = false;
    isPublicCompanyList: boolean = false;
    isPublicSuppressionList: boolean = false;
    tagsCompanyList: number[] = [];
    tagsContactList: number[] = [];
    tagsSuppressionList: number[] = [];

    isLoading: boolean = false;
    tagList$: Observable<TagsDto[]>;
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;

    contactListStore: StoreInterface<ListItemDto>;
    companyListStore: StoreInterface<ListItemDto>;
    suppressionListStore: StoreInterface<ListItemDto>;

    constructor(
        private toastr: ToastrService,
        private commonUtilService: CommonUtilService,
        private listsService: Lists,
        public auth: AuthenticationService,
        public searchService : SearchService,
        private companyInboxService: CompanyinboxService,
        private contactinboxService: ContactinboxService,
        private inboxintelService: InboxintelService,
        private readonly visitorIntelApiService: VisitorIntelApiService,
        private readonly matDialogRef: MatDialogRef<AddToListContactsComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
        private readonly tagsApiService: TagsApiService,
        private readonly loadingService: LoadingService,
        private readonly tagService: TagService,
        private readonly listApiService: ListApiService,
    ) {
        if (this.data.type === 'Contacts' && this.data.isAddAllToListSelected) {
            this.getContactsMatchIds();
        }
        if (this.data.type === 'Companies' && this.data.isAddAllToListSelected) {
            if (this.data.isVisitorIntel) {
                this.getVisitorIntelIds(this.data.provider);
            } else {
                this.getCompanyIds();
            }
        }
        this.setTagsList();

        this.contactListStore = this.createListStore(['Contacts']);
        this.companyListStore = this.createListStore(['Companies']);
        this.suppressionListStore = this.createListStore(['Suppression']);
    }

    onSaveList() {
        if (this.isLoading) {
            return false;
        }

        if (this.isValid()) {
            return false;
        }
        const requestBody = this.prepareBody();
        if (this.selectedType === 'existingContactList' || this.selectedType === 'newContactList' || this.selectedType === 'existingCompanyList' || this.selectedType === 'newCompanyList') {
            if (this.data.type === 'Contacts') {
                this.isLoading = true;
                const request = { inboxIntelContactIds: this.data.records.map((contact) => contact.inboxIntelContactId) };
                this.listsService.tagContacts(requestBody).subscribe((res) => {
                    this.isLoading = false;
                    this.toastr.success((requestBody.contacts.length === 1 ? 'Contact' : 'Contacts') + ' added to list successfully');
                    this.onClose();
                    this.refreshList();
                    if (this.data.isInboxintel) {
                        this.contactinboxService.tagInboxIntelContacts(request).subscribe((_res) => {
                            this.isLoading = false;
                            this.inboxintelService.getStats();
                            this.toastr.success((request.inboxIntelContactIds.length === 1 ? 'Contact' : 'Contacts') + ' added to list successfully');
                            this.onClose();
                        }, () => {
                            this.isLoading = false;
                        });
                    }
                }, () => {
                    this.isLoading = false;
                });
            }

            if (this.data.type === 'Companies') {
                this.isLoading = true;
                const request = { inboxIntelCompanyIds: this.data.records.map((company) => company.inboxIntelCompanyId) };
                this.listsService.tagCompanies(requestBody).subscribe((res) => {
                    this.isLoading = false;
                    this.toastr.success((requestBody.companies.length === 1 ? 'Company' : 'Companies') + ' added to list successfully');
                    this.onClose();
                    this.refreshList();
                    if (this.data.isInboxintel) {
                        this.companyInboxService.tagInboxIntelCompanies(request).subscribe((_res) => {
                            this.isLoading = false;
                            this.inboxintelService.getStats();
                            this.toastr.success((request.inboxIntelCompanyIds.length === 1 ? 'Company' : 'Companies') + ' added to list successfully');
                            this.onClose();
                        }, () => {
                            this.isLoading = false;
                        });
                    }

                }, () => {
                    this.isLoading = false;
                });
            }
        }
        if (this.selectedType === 'suppressionList' || this.selectedType === 'newSuppressionList') {
            this.isLoading = true;
            this.listsService.tagSuppressions(requestBody).subscribe((res) => {
                this.isLoading = false;
                if (this.data.type === 'Contacts') {
                    // if (this.data.isAddAllToListSelected) {
                    this.toastr.success((requestBody.matchIds.length === 1 ? 'Contact' : 'Contacts') + ' added to list successfully');
                    //  } else {
                    //      this.toastr.success((requestBody.emails.length === 1 ? 'Contact' : 'Contacts') + ' added to list successfully');
                    //  }
                    const request = { inboxIntelContactIds: this.data.records.map((contact) => contact.inboxIntelContactId) };
                    if (this.data.isInboxintel) {
                        this.contactinboxService.tagInboxIntelContacts(request).subscribe((_res) => {
                            this.isLoading = false;
                            this.inboxintelService.getStats();
                            this.toastr.success((request.inboxIntelContactIds.length === 1 ? 'Contact' : 'Contacts') + ' added to list successfully');
                            this.onClose();
                        }, () => {
                            this.isLoading = false;
                        });
                    }
                }
                if (this.data.type === 'Companies') {
                    this.toastr.success((requestBody.domains.length === 1 ? 'Company' : 'Companies') + ' added to list successfully');
                    const request = { inboxIntelCompanyIds: this.data.records.map((company) => company.inboxIntelCompanyId) };
                    if (this.data.isInboxintel) {
                        this.companyInboxService.tagInboxIntelCompanies(request).subscribe((_res) => {
                            this.isLoading = false;
                            this.inboxintelService.getStats();
                            this.toastr.success((request.inboxIntelCompanyIds.length === 1 ? 'Company' : 'Companies') + ' added to list successfully');
                            this.onClose();
                        }, () => {
                            this.isLoading = false;
                        });
                    }
                }
                this.onClose();
                this.refreshList();
            }, () => {
                this.isLoading = false;
            });
        }
    }

    private prepareBody() {
        let requestBody: any;
        switch (this.selectedType) {
            case 'existingContactList':
                requestBody = {
                    'listId': this.contactListId,
                    'name': '',
                    'addAll': true,
                    'contacts': this.getContacts(this.data.records)
                };
                break;
            case 'newContactList':
                requestBody = {
                    'name': this.newContactListName.trim(),
                    'addAll': true,
                    'contacts': this.getContacts(this.data.records),
                    isPublic: this.isPublicContactList,
                    tags: [...this.tagsContactList]
                };
                break;

            case 'existingCompanyList':
                requestBody = {
                    'listId': this.companyListId,
                    'name': '',
                    'companies': this.getCompanies(this.data.records)
                };
                break;
            case 'newCompanyList':
                requestBody = {
                    'name': this.newCompanyListName.trim(),
                    'companies': this.getCompanies(this.data.records),
                    isPublic: this.isPublicCompanyList,
                    tags: [...this.tagsCompanyList]
                };
                break;
            case 'suppressionList':
                requestBody = {
                    'listId': this.suppressionListId,
                    'name': '',
                    'matchIds': [],
                    'machineIds': [],
                    'unmatchedIds': []
                };
                if (this.data.type === 'Contacts') {
                    requestBody.isCompanyTab = false;
                    if (this.data.isAddAllToListSelected) {
                        requestBody.matchIds = this.data.records;
                    } else {
                        if (this.data.isInboxintel) {
                            this.data.records.map((contact) => {
                                if (contact['searchResult'] && contact['searchResult'].matchId) {
                                    if (contact['searchResult'] && contact['searchResult'].verified) {
                                        requestBody.matchIds.push(contact['searchResult'].matchId);
                                    } else {
                                        requestBody.machineIds.push(contact['searchResult'].matchId);
                                    }
                                } else {
                                    requestBody.unmatchedIds.push(contact.inboxIntelContactId);
                                }
                            });
                        } else {
                            requestBody.matchIds = this.data.records.map((data) => data.matchId);
                        }
                    }
                }
                if (this.data.type === 'Companies') {
                    requestBody.isCompanyTab = true;
                    if (this.data?.isVisitorIntel) {
                        requestBody.domains = this.data.records
                            .filter((data) => data.companyId)
                            .map((data) => data.companyInfo?.primary_domain || data.companyDomain)
                            .filter((data) => data)
                    } else {
                        requestBody.domains = this.data.isInboxintel ? this.data.records.map((data) => data.searchResult.primary_domain)
                            : this.data.records.map((data) => data.primary_domain); // DAAS-6711
                    }
                }
                break;
            case 'newSuppressionList':
                requestBody = {
                    'name': this.newSuppressionListName.trim(),
                    'matchIds': [],
                    'machineIds': [],
                    'unmatchedIds': [],
                    isPublic: this.isPublicSuppressionList,
                    tags: [...this.tagsSuppressionList]
                };
                if (this.data.type === 'Contacts') {
                    requestBody.isCompanyTab = false;
                    if (this.data.isAddAllToListSelected) {
                        requestBody.matchIds = this.data.records;
                    } else {
                        if (this.data.isInboxintel) {
                            this.data.records.map((contact) => {
                                if (contact['searchResult'] && contact['searchResult'].matchId) {
                                    if (contact['searchResult'] && contact['searchResult'].verified) {
                                        requestBody.matchIds.push(contact['searchResult'].matchId);
                                    } else {
                                        requestBody.machineIds.push(contact['searchResult'].matchId);
                                    }
                                } else {
                                    requestBody.unmatchedIds.push(contact.inboxIntelContactId);
                                }
                            });
                        } else {
                            requestBody.matchIds = this.data.records.map((data) => data.matchId);
                        }

                    }
                }
                if (this.data.type === 'Companies') {
                    requestBody.isCompanyTab = true;
                    if (this.data?.isVisitorIntel) {
                        requestBody.domains = this.data.records
                            .filter((data) => data.companyId)
                            .map((data) => data.companyInfo?.primary_domain || data.companyDomain)
                            .filter((data) => data)
                    } else {
                        requestBody.domains = this.data.isInboxintel ? this.data.records.map((data) => data.searchResult.primary_domain)
                            : this.data.records.map((data) => data.primary_domain); // DAAS-6711
                    }
                }
                break;
        }
        return requestBody;
    }

    onClose() {
        this.matDialogRef.close();
    }

    reset() {
        this.contactListId = '';
        this.newContactListName = '';
        this.companyListId = '';
        this.newCompanyListName = '';
        this.suppressionListId = '';
        this.newSuppressionListName = '';
        this.tagsCompanyList = [];
        this.tagsContactList = [];
        this.tagsSuppressionList = [];
    }

    createTag(tagName: string): void {
        const createObj: SaveTagDto = {
            name: tagName
        }
        this.loadingService.loadingWrapper(this.tagsApiService.createTag(createObj), CREATE_TAG_LOADING_TAG).pipe(untilDestroyed(this)).subscribe((newTag: TagsDto) => {
            this.updateTagList(newTag.id);
            this.tagService.refreshList();
            this.toastr.success("Tag created successfully");
        })
    }

    onContactListChanged(item: ListItemDto | null): void {
        this.contactListId = item?.id ?? '';
    }

    onCompanyListChanged(item: ListItemDto | null): void {
        this.companyListId = item?.id ?? '';
    }

    onSuppressionListChanged(item: ListItemDto | null): void {
        this.suppressionListId = item?.id ?? '';
    }

    private updateTagList(newTagId: number): void {
        switch (this.selectedType) {
            case 'newCompanyList':
                this.tagsCompanyList = [...this.tagsCompanyList, newTagId];
                break;
            case 'newContactList':
                this.tagsContactList = [...this.tagsContactList, newTagId];
                break;
            case 'newSuppressionList':
                this.tagsSuppressionList = [...this.tagsSuppressionList, newTagId];
                break;
        }
    }

    private isValid() {
        const listMessgae = 'List Name is required.';
        if (this.selectedType === 'newContactList') {
            if (!this.newContactListName.trim()) {
                this.commonUtilService.showToastWithError(listMessgae);
                return true;
            }
        }
        if (this.selectedType === 'newCompanyList') {
            if (!this.newCompanyListName.trim()) {
                this.commonUtilService.showToastWithError(listMessgae);
                return true;
            }
        }
        if (this.selectedType === 'newSuppressionList') {
            if (!this.newSuppressionListName.trim()) {
                this.commonUtilService.showToastWithError(listMessgae);
                return true;
            }
        }

        return false;
    }

    private getContacts(contacts) {
        if (this.data.isAddAllToListSelected) {
            if (this.data.isInboxintel) {
                return this.getInboxintelTagContacts(contacts);
            } else {
                return contacts.map((contactId) => {
                    return {
                        'matchId': contactId
                    };
                });
            }
        } else {
            if (this.data.isInboxintel) {
                return this.getInboxintelTagContacts(contacts);
            } else {
                return contacts.map((data) => {
                    let domain = '';
                    if (data.companyDomains && data.companyDomains.length) {
                        domain = data.companyDomains[0];
                    }
                    return {
                        'matchId': data.matchId,
                        // 'firstName': data.firstName,
                        // 'lastName': data.lastName,
                        // 'email': data.email,
                        // 'company': data.companyName,
                        // 'domain': domain,
                        // 'title': data.jobTitle,
                        // 'workPhone': this.getPhoneNumber(data.phoneNumbers, 'work'),
                        // 'workMobile': this.getPhoneNumber(data.phoneNumbers, 'mobile'),
                        // 'hqPhone': this.getPhoneNumber(data.phoneNumbers, 'work_hq'),
                        // 'linkedinUrl': this.getSocialProfiles(data.socialProfiles, 'linkedin')
                    };
                });
            }
        }
    }

    private getCompanies(companies) {
        const companyData = [];
        companies.forEach((element) => {
            let name, domain;
            if (this.data?.isVisitorIntel) {
                if (!this.data.isAddAllToListSelected && !element.companyId && !element.companyInfo?.company_id) {
                    return;
                }
                name = element.companyInfo?.primary_name || element.companyName || '';
                domain = element.companyInfo?.primary_domain || element.companyDomain || '';
            } else {
                let companyInfo = this.data.isInboxintel && element.searchResult?.primary_domain ? element.searchResult : element;
                name = (companyInfo.primary_domain && !this.data.isAddAllToListSelected ? companyInfo.primary_name : companyInfo.name) || '';
                domain = companyInfo.primary_domain || element.domain || '';
            }
            companyData.push({ name, domain });
        });
        return companyData;
    }

    private refreshList() {
        this.listsService.refreshLists();
    }

    private getContactsMatchIds() {
        this.isLoading = true;
        this.searchService.exportAllContactsMatchsId(this.data.requestBody).pipe(untilDestroyed(this)).subscribe((response) => {
            this.isLoading = false;
            this.data.records = response.matchIds;
        }, () => {
            this.isLoading = false;
            this.onClose();
        });
    }

    private getCompanyIds() {
        this.isLoading = true;
        this.searchService.getCompanyIds(this.data.requestBody)
        .pipe(untilDestroyed(this))
        .subscribe((response) => {
            this.isLoading = false;
            this.data.records = response.companies;
        }, () => {
            this.isLoading = false;
            this.onClose();
        });
    }

    private getVisitorIntelIds(provider: VisitorIntelProviderEnum) {
        this.isLoading = true;
        this.visitorIntelApiService.getCompanies(this.data.requestBody, provider)
        .pipe(untilDestroyed(this))
        .subscribe((response: VisitorIntelCompanyDto[]) => {
            this.isLoading = false;
            this.data.records = response;
        }, () => {
            this.isLoading = false;
            this.onClose();
        });
    }

    private getInboxintelTagContacts(contacts) {
        return contacts.map((contact) => {
            if (contact['searchResult'] && contact['searchResult'].matchId) {
                if (contact['searchResult'] && contact['searchResult'].verified) {
                    return {
                        'matchId': contact['searchResult'].matchId
                    }; // matchId
                } else {
                    return {
                        machineId: contact.searchResult.matchId
                    }; // machineId
                }
            } else {
                return {
                    unmatchedId: contact.inboxIntelContactId
                }; // unmatchedId
            }
        });
    }

    private setTagsList(): void {
        this.tagList$ = this.tagService.getTagsList();
    }

    private getErrorText(error: any): string {
        return error?.error?.response || error?.error?.message || error?.data?.response || error?.data?.message || error?.message || 'An error occurred';
    }

    private createListStore(listTypes: string[]): StoreInterface<ListItemDto> {
        let cachedItems: ListItemDto[] | null = null;
        let isAllLoaded: boolean = false;

        return {
            getData: (params: SelectSearchParamsInterface) => {
                if (isAllLoaded && cachedItems && params.page === 1) {
                    const filtered = params.name
                        ? cachedItems.filter(item =>
                            item.name.toLowerCase().includes(params.name.toLowerCase()))
                        : cachedItems;
                    return of({
                        page: 1,
                        pageSize: filtered.length,
                        totalCount: filtered.length,
                        resultCount: filtered.length,
                        content: filtered,
                    });
                }

                const listPayload: ListPayloadDto = {
                    page: params.page,
                    sortBy: 'Name',
                    sortDirection: 'asc',
                    listTypes,
                    isPublic: true,
                    ...(params.name ? { name: params.name } : {}),
                };

                return this.listApiService.getList(listPayload).pipe(
                    map((response: ListResponseDto) => {
                        const decoded: ListItemDto[] = this.listsService.getListRawData(response.items || []);

                        if (!isAllLoaded && response.totalCount <= decoded.length) {
                            cachedItems = decoded;
                            isAllLoaded = true;
                        }

                        return {
                            page: response.page,
                            pageSize: response.pageSize,
                            totalCount: response.totalCount,
                            resultCount: decoded.length,
                            content: decoded,
                        };
                    })
                );
            },
        };
    }

}
